import { formatNumber, formatPercent } from '@angular/common';
import { endOfDay } from 'date-fns';

import { AxisLeftTick } from '../../scorecard-mi2/chart/axis-left-tick';
import { AxisRightTick } from '../../scorecard-mi2/chart/axis-right-tick';
import { TrendAxisDataAxisPathPointInsight } from '../../scorecard-mi2/trend-dialog/model/trend-axis-data-axis-path-point-insight.model ';
import { Mi2ScoreData } from '../models/mi2-score-data';

import { getLeftTicks } from './get-left-ticks.function';

export function getScorecardChart(
    data: Mi2ScoreData[],
    name: string,
): {
    leftTicks: AxisLeftTick[];
    rightTicks: AxisRightTick[];
    points: TrendAxisDataAxisPathPointInsight[];
} {
    const leftTicks: AxisLeftTick[] = getLeftTicks();

    const points = data
        ?.filter((e) => e.actual != null)
        .map<TrendAxisDataAxisPathPointInsight>((e) => {
            const pd = (e.periodDate as any as string)?.trim()?.toLowerCase();
            return {
                x: endOfDay(
                    pd?.endsWith('z')
                        ? new Date(pd.slice(0, -1))
                        : new Date(pd),
                ),
                y: e.actual / 10,
                color: ' #1e60d4',
                actual: formatNumber(e?.actual, 'en-CA', '1.0-1'),
                name,
                target:
                    e.target != null
                        ? formatNumber(e.target, 'en-CA', '1.0-2')
                        : '-',
                pctToTarget: formatPercent(e?.pctToTarget, 'en-CA', '1.0-2'),
            };
        })
        .filter((e) => e.y != null && e.y !== 0);

    return { leftTicks, rightTicks: [], points };
}
